var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgValidatorStaking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.08 3.47979C6.18052 1.37928 9.02943 0.199219 12 0.199219C14.9706 0.199219 17.8195 1.37928 19.92 3.47979C22.0205 5.58031 23.2006 8.42921 23.2006 11.3998C23.2006 14.3704 22.0205 17.2193 19.92 19.3198L12 27.2398L4.08 19.3198C3.03987 18.2798 2.21478 17.045 1.65185 15.6861C1.08893 14.3272 0.799194 12.8707 0.799194 11.3998C0.799194 9.92889 1.08893 8.47239 1.65185 7.11347C2.21478 5.75455 3.03987 4.51982 4.08 3.47979ZM12 14.5998C12.8487 14.5998 13.6626 14.2626 14.2627 13.6625C14.8629 13.0624 15.2 12.2485 15.2 11.3998C15.2 10.5511 14.8629 9.73716 14.2627 9.13705C13.6626 8.53693 12.8487 8.19979 12 8.19979C11.1513 8.19979 10.3374 8.53693 9.73726 9.13705C9.13714 9.73716 8.8 10.5511 8.8 11.3998C8.8 12.2485 9.13714 13.0624 9.73726 13.6625C10.3374 14.2626 11.1513 14.5998 12 14.5998Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValidatorStaking);
export default __webpack_public_path__ + "static/media/validator-staking.c943030fae77f7d32f5fdb01a09a56ae.svg";
export { ForwardRef as ReactComponent };